module.exports = __webpack_public_path__ + "images/emoji/dog.b5e1f13a6f0c0555d0a7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dog.png
// module id = uXiO
// module chunks = 13